// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_b6-4";
export var collapsed = "_b6-1";
export var headerBar = "_b6-0";
export var leftHeaderContent = "_b6-3";
export var subjectContainer = "_b6-2";